// THIS IS V2 separated methods on single bookpart
import { createAxiosInstance } from '@speechki-frontend/shared/axios';
import isEmpty from 'lodash/isEmpty';

const BASE_URL = process.env.VUE_APP_BASE_URL;
const prefix = `/api/v2`;
const URL = BASE_URL + prefix;

const axios = createAxiosInstance(BASE_URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchBookpart = (id, params = {}) => {
    return axios.get(URL + `/book_parts/${id}/`, {
        params
    });
};

export const updateBookpart = (id, data = {}, params = {}) => {
    if (isEmpty(data)) {
        throw new Error('Bookpart update failed: no data passed');
    }

    return axios.patch(URL + `/book_parts/${id}/`, data, { params });
};

export const swapBookpartType = (id, data = {}, params = {}) => {
    if (isEmpty(data) || !data.type_part) {
        throw new Error('Bookpart update failed: invalid data');
    }

    return axios.patch(URL + `/book_parts/${id}/swap_type/`, data, { params });
};

export const generateBookpart = (id, data = {}, params = {}) => {
    return axios.post(`${URL}/book_parts/${id}/generate/`, data, { params });
};

export const checkBookpartGenerationState = async id => {
    const { in_queue: inQueue = false } = await axios.get(`${URL}/book_parts/${id}/in_queue/`);

    return { id, inQueue };
};

export const splitBookpart = (id, sentences, params = {}) => {
    return axios.post(
        `${URL}/book_parts/${id}/split/`,
        {
            sentences
        },
        { params }
    );
};

export const deleteBookpart = (id, params = {}) => {
    return axios.delete(`${URL}/book_parts/${id}/`, { params });
};

// temporary until we also move books to v2
// TODO move to books api
export const setBookPauseDuration = (id, data = {}, params = {}) => {
    if (!data.duration || !data.type_part) {
        throw new Error('Pause duration update failed: invalid data');
    }

    return axios.put(URL + `/books/${id}/pause_duration/`, data, { params });
};
